/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-hospital-association.reducer';

export const LabHospitalAssociationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labHospitalAssociationEntity = useAppSelector(state => state.labHospitalAssociation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labHospitalAssociationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.detail.title">LabHospitalAssociation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.id">Id</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.id}</dd>
          <dt>
            <span id="associatedDate">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.associatedDate">Associated Date</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.associatedDate}</dd>
          <dt>
            <span id="leavingDate">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.leavingDate">Leaving Date</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.leavingDate}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.active">Active</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.cursor}</dd>
          <dt>
            <span id="openingTime">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.openingTime">Opening Time</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.openingTime}</dd>
          <dt>
            <span id="closeTime">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.closeTime">Close Time</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.closeTime}</dd>
          <dt>
            <span id="internal">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.internal">Internal</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.internal ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.modifiedBy}</dd>
          <dt>
            <span id="leftAssociation">
              <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.leftAssociation">Left Association</Translate>
            </span>
          </dt>
          <dd>{labHospitalAssociationEntity.leftAssociation ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{labHospitalAssociationEntity.diagLab ? labHospitalAssociationEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.hospital">Hospital</Translate>
          </dt>
          <dd>{labHospitalAssociationEntity.hospital ? labHospitalAssociationEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-hospital-association" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-hospital-association/${labHospitalAssociationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabHospitalAssociationDetail;
